import React from 'react';
import { Landing } from './pages/Landing';
interface AppProps {
  /** Mostrar la sección de experiencias (solo con testimonios reales autorizados). */
  showTestimonials?: boolean;
  /** Mostrar "Consulta inicial sin costo." (solo si la consulta no tiene costo obligatorio). */
  freeInitialConsultation?: boolean;
}
const BRAND_LOCKUP = 'Rituales y Orientación Espiritual';
export function App({
  showTestimonials = true,
  freeInitialConsultation = true
}: AppProps) {
  return <Landing lockup={BRAND_LOCKUP} showTestimonials={showTestimonials} freeInitialConsultation={freeInitialConsultation} data-id="element-0" data-mp="2mm2lgdnsqr2w" />;
}